import { HTTP } from '../../services';
import { ApiBaseURL} from '../../environment';

import { HTTPService } from './API.services';

const httpService = new HTTPService(HTTP, `${ApiBaseURL}/generic`)

const servicesList =  {
    httpService
}

export default servicesList;

